import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=8b26118e&"
import script from "./Categorias.vue?vue&type=script&lang=js&"
export * from "./Categorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports